import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';

// disabling strict mode for now because of a buggy createMuiTheme when swapping themes
// an unstable alternative is being developed: https://material-ui.com/customization/theming/#unstable-createmuistrictmodetheme-options-args-theme

if (process.env.NODE_ENV === 'development') {
  // const { worker } = require('./mocks/browser');
  // worker.start();
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
